// extracted by mini-css-extract-plugin
export default {"hidden":"Input_hidden__204XJ","input":"Input_input__HYbVo","send":"Input_send__wWNRH"};